import * as leadApi from "../../services/lead";

const PORTAL_SIGN_UP_URL =
  process.env.ENV === "prod"
    ? "portal.sendpayments.com/signup"
    : `portal-${process.env.ENV}.env.sendfx.net/signup`;
const ERROR_URL = "sendpayments.com/error";

const SUCCESS_REDIRECT_URL =
  process.env.ENV === "prod"
    ? "partner.sendpayments.com.au/thank-you"
    : "partner.sendpayments.com.au/thank-you-uat";

const trimSpaces = (obj) =>
  Object.keys(obj).reduce((acc, curr) => {
    acc[curr] = typeof obj[curr] === "string" ? obj[curr].trim() : obj[curr];
    return acc;
  }, {});

const leadsWidgetFormSubmit = async (
  affiliateId,
  formValues,
  showDetailForm,
  setSubmitting,
  trackingId,
  metadata
) => {
  const { transferValue, email, ...rest } = trimSpaces(formValues);

  if (!showDetailForm) {
    redirectSendPortal(affiliateId);
    return false;
  }

  try {
    const lead = {
      ...(affiliateId && { affiliateId }),
      ...(trackingId && { trackingId }),
      ...(metadata && { metadata }),
      estimatedValue: transferValue,
      leadSource: "leads-widget",
      email: email.toLowerCase(),
      ...rest,
    };
    await leadApi.save(lead);
    redirectSuccessPage(affiliateId);
    return true;
  } catch (error) {
    if (error.response && error.response.status >= 500) {
      console.log(error.response.status);
      redirectErrorPage();
    }
  } finally {
    setSubmitting(false);
  }
  return false;
};

/**
 * @param {string} affiliateId
 */
const redirectSendPortal = (affiliateId) => {
  const url = new URL(`https://${PORTAL_SIGN_UP_URL}`);

  if (affiliateId) {
    url.searchParams.append("affiliateId", affiliateId);
  }

  window.top.location.href = url.href;
};

const redirectSuccessPage = (affiliateId) => {
  const url = new URL(`https://${SUCCESS_REDIRECT_URL}`);

  if (affiliateId) {
    url.searchParams.append("affiliateId", affiliateId);
  }

  window.top.location.href = url.href;
};

const redirectErrorPage = () => {
  window.top.location.href = `https://${ERROR_URL}`;
};

export default leadsWidgetFormSubmit;
